import React from "react";
import { useNavigate } from "react-router-dom";
import placeholderImage from "../assets/images/patties.jpg";

function MenuCalloutSection() {
  const navigate = useNavigate();

  const menuItems = [
    { label: "HOME", href: "/" },
    { label: "ABOUT US", href: "#about" },
    { label: "OUR MENU", href: "#menu" },
    { label: "CATERING", href: "/catering" },
    { label: "CONTACT US", href: "#contact" },
  ];

  const handleClick = (href) => {
    // If it's a route path, navigate
    if (href.startsWith("/")) {
      navigate(href);
    } else {
      // Otherwise scroll to section
      const navbarHeight = 128; // h-32 = 8rem = 128px
      const element = document.querySelector(href);
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - navbarHeight,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <section className="relative h-96 overflow-hidden bg-cover bg-center bg-fixed">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${placeholderImage})`,
        }}
      />

      {/* Overlay for parallax effect */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Menu Items Container */}
      <div className="relative h-full flex items-center justify-center">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-8 px-4">
          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleClick(item.href)}
              className="px-6 py-4 md:px-8 md:py-6 font-bold text-white text-sm md:text-base transition-all duration-300"
              style={{
                backgroundColor: "#f2340a",
                opacity: 1,
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = "0.3";
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = "1";
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MenuCalloutSection;
